import ErrorReporter from "@/services/ErrorReporter"
import { computed, isRef, unref, type MaybeRef } from "vue"

const staleTimeInMs = 1000 * 10

export const useQueryOptions = <TOptions>(
  options: TOptions,
  params: { [key: string]: MaybeRef },
): TOptions => {
  return {
    retry: false,
    staleTime: staleTimeInMs,
    enabled: computed(() =>
      Object.values(params)
        .filter((param) => isRef(param))
        .every((v) => !!unref(v)),
    ),
    throwOnError: (error: Error) => {
      ErrorReporter.report(error)
      return false
    },
    ...options,
  } as const
}
